import { ariaDescribedByIds } from '@rjsf/utils';
import { useCallback } from 'react';

const TextareaWidget = ({
  id,
  options = {},
  placeholder,
  value,
  required,
  disabled,
  readonly,
  onChange,
  onBlur,
  onFocus,
  htmlName,
}) => {
  const handleChange = useCallback(({ target }) => onChange(target.value === '' ? options.emptyValue : target.value), [
    onChange,
    options.emptyValue,
  ]);
  const handleBlur = useCallback(({ target }) => onBlur(id, target && target.value), [onBlur, id]);
  const handleFocus = useCallback(({ target }) => onFocus(id, target && target.value), [id, onFocus]);
  const rows = options.rows || options.minLines;
  const maxLines = options.maxLines || rows;

  return (
    <textarea
      style={{
        maxHeight: maxLines ? `${maxLines * 2}em` : '150px',
        fieldSizing: 'content',
        overflowY: 'auto',
      }}
      id={id}
      name={htmlName || id}
      className="form-control"
      value={value || ''}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      readOnly={readonly}
      rows={rows}
      onBlur={handleBlur}
      onFocus={handleFocus}
      onChange={handleChange}
      aria-describedby={ariaDescribedByIds(id)}
    />
  );
};

export default TextareaWidget;
